export default [{
  path: '/control',
  meta: {
    keepAlive: true,
    pathName: 'home'
  },
  component: resolve => require(['../view/control/index'], resolve),
  children: [{
      path: 'department',
      meta: {
        keepAlive: true,
        pathName: 'department'
      },
      component: resolve => require(['../view/control/department'], resolve)
    },
    {
      path: 'staff',
      meta: {
        keepAlive: true,
        pathName: 'staff'
      },
      component: resolve => require(['../view/control/staff'], resolve)
    },
    {
      path: 'channel',
      meta: {
        keepAlive: true,
        pathName: 'channel'
      },
      component: resolve => require(['../view/control/channel'], resolve)
    },
    {
      path: 'store',
      meta: {
        keepAlive: true,
        pathName: 'store'
      },
      component: resolve => require(['../view/control/store'], resolve)
    },
    {
      path: 'permission',
      meta: {
        keepAlive: true,
        pathName: 'permission'
      },
      component: resolve => require(['../view/control/permission'], resolve)
    },
    {
      path: 'ip_auth',
      meta: {
        keepAlive: true,
        pathName: 'ip_auth'
      },
      component: resolve => require(['../view/control/ip_auth'], resolve)
    },{
      path: 'shop',
      meta: {
        keepAlive: true,
        pathName: 'shop'
      },
      component: resolve => require(['../view/control/shop'], resolve)
    },
    {
      path: 'system',
      meta: {
        keepAlive: true,
        pathName: 'system'
      },
      component: resolve => require(['../view/control/system'], resolve)
    },
    {
      path: 'sys_log',
      component: resolve => require(['../view/control/sys-log'], resolve)
    },
    //表头配置
    {
      path: 'page_set',
      meta: {
        keepAlive: false,
      },
      component: resolve => require(['../view/control/page-set'], resolve)
    }
  ]
}]



// WEBPACK FOOTER //
// ./src/router/control.js